import { Controller } from "stimulus";
import  stylesArray  from "./map_styles";

export default class extends Controller {
  static targets = ['coordinates', 'map']

  connect() {
    this.appendScript();
  }

  appendScript() {
    const leafletCSS = document.createElement('link');
    leafletCSS.rel = 'stylesheet';
    leafletCSS.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(leafletCSS);

    // Create and append Leaflet JS
    const leafletScript = document.createElement('script');
    leafletScript.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    document.head.appendChild(leafletScript);

    console.info(this.coordinatesTarget);
    // Initialize map after script is loaded
    leafletScript.onload =  () => {
      this.constructMap();
    }
  }

  constructMap() {
    const parent = this.element.querySelector('.ListingSingleMap__content');
    let mapDiv = this.element.querySelector('#map');
    if(!mapDiv) {
      mapDiv = document.createElement('div');
      mapDiv.id = 'map';
      mapDiv.style.height = '520px';
      parent.appendChild(mapDiv);
    }

    this.createMap();
  }

  createMap() {
    const latitude = Number(this.coordinatesTarget.dataset.latitude);
    const longitude = Number(this.coordinatesTarget.dataset.longitude);

    const zoomLevel = 13;
    const markers = this.element.querySelector('.ListingSingleMap__map-marker');
    const map = L.map('map').setView([latitude, longitude], zoomLevel);
    // Add OpenStreetMap tile layer
    // markers.dataset.mapMarkerSrc
    L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    const title = document.querySelector('.js-ListingSingleMap__title').innerHTML;
    const minRate = document.querySelector('.js-ListingSingleMap__min-rate').innerHTML;
    L.marker([latitude, longitude]).addTo(map)
      .bindPopup(`${title} <br> Starting at $${minRate}`)
        .openPopup();
  }
}
